<script>
  export let src;

  let gifSrc = src;

  function replay() {
    gifSrc = `${src}?t=${Date.now()}`;
  }
</script>

<img
  src={gifSrc}
  alt="Sticker"
  class="w-24 h-24 object-contain cursor-pointer select-none"
  loading="lazy"
  on:mouseenter={replay}
  on:click={replay}
  on:touchstart|preventDefault={replay} />
